import AiSuggestionsTrigger from '@/components/AiSuggestionsTrigger.jsx';
import AiArgumentsSuggestionsPopover from '@/components/aiSuggestions/AiArgumentsSuggestionsPopover.jsx';
import { HiOutlineSparkles } from '@/components/react-icons/main';
import { actionArgumentListSuggestions } from '@/redux/selectors/aiSelectors';
import { useSelector } from 'react-redux';
import Button from './Button.jsx';

const AiArgumentsSuggestions = ({ size = 'md', outlined = true, location, row = false }) => {
  const suggestions = useSelector(actionArgumentListSuggestions) || [];
  const filteredSuggestions = location ? suggestions?.filter((suggestion) => suggestion.location === location) : suggestions;

  if (!filteredSuggestions || filteredSuggestions?.length === 0) {
    return null;
  }

  if (row) {
    return (
      <AiArgumentsSuggestionsPopover location={location}>
        <div className={'suggestions-row'}>
          <Button icon={HiOutlineSparkles} className={'full-width dashed salmon'} stopPropagation={false}>
            {filteredSuggestions?.length} AI Suggestion{filteredSuggestions?.length === 1 ? '' : 's'}
          </Button>
        </div>
      </AiArgumentsSuggestionsPopover>
    );
  }

  return (
    <AiArgumentsSuggestionsPopover location={location}>
      <AiSuggestionsTrigger hasSuggestions={filteredSuggestions?.length > 0} suggestionsLength={filteredSuggestions?.length} showCount outlined={outlined} size={size} title={`${filteredSuggestions?.length} AI Suggestions`} />
    </AiArgumentsSuggestionsPopover>
  );
};

export default AiArgumentsSuggestions;
